const locales = ['de', 'en'] as const

export const localeTranslations = {
  de: {
    en: 'Englisch',
    de: 'Deutsch',
  },
  en: {
    en: 'English',
    de: 'German',
  },
} as const

export default locales
